import { css } from 'styled-components';
import { rem, media } from '../../../helpers/mixins';
import { GRAY, BLACK } from '../../../constants/colors';

export default {
  questionWrapper: css`
    display: flex;
    flex: 1;
    border-bottom: 1px solid ${GRAY};
    cursor: pointer;
  `,
  question: css`
    display: block;
    font-size: ${rem('14px')};
    color: ${BLACK};
    padding: 8px 0;
    flex: 1;

    ${media.sm`
      font-size: ${rem('20px')};
    `}
  `,
  answerWrapper: props => css`
    display: block;
    overflow: hidden;
    transition: all 0.3s ease-out;
    will-change: auto;
    max-height: 0;

    ${props.isActive && css`
      will-change: max-height;
      transition: max-height 0.3s ease-in-out;
      max-height: 100%;
    `};
  `,
  answer: ({ isActive }) => css`
    transform: translate3d(0, 30px, 0);
    transition: all 0.3s ease-out;
    will-change: auto;
    padding: 16px 0;
    font-size: ${rem('14px')};
    opacity: 0;

    ${isActive && css`
      will-change: transform, opacity;
      opacity: 1;
      transition: opacity 0.25s ease-out, transform 0.25s ease-out;
      transform: translate3d(0, 0, 0);
    `};

    ${media.sm`
      font-size: ${rem('16px')};
    `}
  `
};
